<template>
  <!-- <pre v-if="responseData">  test data :: {{ responseData }}</pre>  -->
  <Background v-if="stateData && responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/PASAR PBT.png"
        alt="PASAR PBT"
        class="pbt-image"
      />

      <div class="line-under-image" />
    </div>

    <div class="content-wrapper">
      <h2>BILANGAN LOKASI & LESEN</h2>

      <div class="pasar">
        <div class="pasar-container">
          <img src="@/assets/pasar/jenisPasar/tani.png" alt="First Image" />
          <div class="text-overlay-left">
            <h3>PASAR TANI</h3>
            <div class="values-side-by-side">
              <p>
                <span class="value number">{{
                  numberWithCommas(keseluruhan.bilangan_pasar_tani)
                }}</span>
                <span class="text">Lokasi</span>
              </p>
              <p>
                <span class="value number">{{
                  numberWithCommas(keseluruhan.lesen_pasar_tani)
                }}</span>
                <span class="text">Lesen</span>
              </p>
            </div>
          </div>
        </div>

        <div class="pasar-container">
          <img src="@/assets/pasar/jenisPasar/pagi.png" alt="Second Image" />
          <div class="text-overlay-right">
            <h3>PASAR PAGI</h3>
            <div class="values-side-by-side">
              <p>
                <span class="value number">{{
                  numberWithCommas(keseluruhan.bilangan_pasar_pagi)
                }}</span>
                <span class="text">Lokasi</span>
              </p>
              <p>
                <span class="value number">{{
                  numberWithCommas(keseluruhan.lesen_pasar_pagi)
                }}</span>
                <span class="text">Lesen</span>
              </p>
            </div>
          </div>
        </div>

        <div class="pasar-container">
          <img src="@/assets/pasar/jenisPasar/malam.png" alt="Third Image" />
          <div class="text-overlay-left">
            <h3>PASAR MALAM</h3>
            <div class="values-side-by-side">
              <p>
                <span class="value number">{{
                  numberWithCommas(keseluruhan.bilangan_pasar_malam)
                }}</span>
                <span class="text">Lokasi</span>
              </p>
              <p>
                <span class="value number">{{
                  numberWithCommas(keseluruhan.lesen_pasar_malam)
                }}</span>
                <span class="text">Lesen</span>
              </p>
            </div>
          </div>
        </div>

        <div class="pasar-container">
          <img src="@/assets/pasar/jenisPasar/minggu.png" alt="Fourth Image" />
          <div class="text-overlay-right">
            <h3>PASAR MINGGU</h3>
            <div class="values-side-by-side">
              <p>
                <span class="value number">{{
                  numberWithCommas(keseluruhan.bilangan_pasar_minggu)
                }}</span>
                <span class="text">Lokasi</span>
              </p>
              <p>
                <span class="value number">{{
                  numberWithCommas(keseluruhan.lesen_pasar_minggu)
                }}</span>
                <span class="text">Lesen</span>
              </p>
            </div>
          </div>
        </div>

        <div class="pasar-container">
          <img src="@/assets/pasar/jenisPasar/tamu.png" alt="Fifth Image" />
          <div class="text-overlay-left">
            <h3>PASAR TAMU</h3>
            <div class="values-side-by-side">
              <p>
                <span class="value number">{{
                  numberWithCommas(keseluruhan.bilangan_pasar_tamu)
                }}</span>
                <span class="text">Lokasi</span>
              </p>
              <p>
                <span class="value number">{{
                  numberWithCommas(keseluruhan.lesen_pasar_tamu)
                }}</span>
                <span class="text">Lesen</span>
              </p>
            </div>
          </div>
        </div>

        <div class="pasar-container">
          <img src="@/assets/pasar/jenisPasar/jumlah.png" alt="Sixth Image" />
          <div class="text-overlay-center">
            <h3>JUMLAH PASAR</h3>
            <div class="values-side-by-side">
              <p>
                <span class="value number">{{
                  numberWithCommas(keseluruhan.jumlah_lokasi)
                }}</span>
                <span class="text">Lokasi</span>
              </p>
              <p>
                <span class="value number">{{
                  numberWithCommas(keseluruhan.jumlah_lesen)
                }}</span>
                <span class="text">Lesen</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Update />
    </div>

    <div class="content-wrapper">
      <h2>BILANGAN LOKASI PASAR MALAM MENGIKUT NEGERI 2025</h2>
      <div class="image-grid">
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/wilayah.png" alt="W.PERSEKUTUAN" />
          <div class="text-overlay">
            <p class="state-name">WP PUTRAJAYA</p>
            <p>
              <span class="state-number-large">{{
                getStateData("WP Putrajaya") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>

        <!-- PERAK -->
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/perak.png" alt="perak" />
          <div class="text-overlay">
            <p class="state-name">PERAK</p>
            <p>
              <span class="state-number-large">{{
                getStateData("Perak") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>

        <!-- N.SEMBILAN -->
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/sembilan.png" alt="N.SEMBILAN" />
          <div class="text-overlay">
            <p class="state-name">N.SEMBILAN</p>
            <p>
              <span class="state-number-large">{{
                getStateData("Negeri Sembilan") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>

        <!-- KEDAH -->
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/kedah.png" alt="KEDAH" />
          <div class="text-overlay">
            <p class="state-name">KEDAH</p>
            <p>
              <span class="state-number-large">{{
                getStateData("Kedah") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>

        <!-- JOHOR -->
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/johor.png" alt="JOHOR" />
          <div class="text-overlay">
            <p class="state-name">JOHOR</p>
            <p>
              <span class="state-number-large">{{
                getStateData("Johor") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>

        <!-- SARAWAK -->
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/sarawak.png" alt="SARAWAK" />
          <div class="text-overlay">
            <p class="state-name">SARAWAK</p>
            <p>
              <span class="state-number-large">{{
                getStateData("Sarawak") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>

        <!-- SABAH -->
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/sabah.png" alt="SABAH" />
          <div class="text-overlay">
            <p class="state-name">SABAH</p>
            <p>
              <span class="state-number-large">{{
                getStateData("Sabah") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>

        <!-- KELANTAN -->
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/kelantan.png" alt="KELANTAN" />
          <div class="text-overlay">
            <p class="state-name">KELANTAN</p>
            <p>
              <span class="state-number-large">{{
                getStateData("Kelantan") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>

        <!-- SELANGOR -->
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/selangor.png" alt="SELANGOR" />
          <div class="text-overlay">
            <p class="state-name">SELANGOR</p>
            <p>
              <span class="state-number-large">{{
                getStateData("Selangor") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>

        <!-- P.PINANG -->
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/penang.png" alt="P.PINANG" />
          <div class="text-overlay">
            <p class="state-name">P.PINANG</p>
            <p>
              <span class="state-number-large">{{
                getStateData("Pulau Pinang") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>

        <!-- PERLIS -->
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/perlis.png" alt="PERLIS" />
          <div class="text-overlay">
            <p class="state-name">PERLIS</p>
            <p>
              <span class="state-number-large">{{
                getStateData("Perlis") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>

        <!-- MELAKA -->
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/melaka.png" alt="MELAKA" />
          <div class="text-overlay">
            <p class="state-name">MELAKA</p>
            <p>
              <span class="state-number-large">{{
                getStateData("Melaka") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>

        <!-- TERANGGANU -->
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/terengganu.png" alt="TERENGGANU" />
          <div class="text-overlay">
            <p class="state-name">TERENGGANU</p>
            <p>
              <span class="state-number-large">{{
                getStateData("Terengganu") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>
        <div class="image-container">
          <img src="@/assets/pasar/lokasi/pahang.png" alt="PAHANG" />
          <div class="text-overlay">
            <p class="state-name">PAHANG</p>
            <p>
              <span class="state-number-large">{{
                getStateData("Pahang") ?? 0
              }}</span>
              <span class="state-lokasi-large"> Lokasi</span>
            </p>
          </div>
        </div>
      </div>
      <Update />
    </div>
  </Background>
  <Menu />
</template>

<script setup>
import Background from "@/components/background/background.vue";
import Menu from "@/components/menu-items/utama-menu.vue";
import { useHttpService } from "@/httpService";
import { onMounted, ref } from "vue";

definePage({
  alias: "/pages/pages/inspektorat/ahli-pbt",
  meta: {
    layout: "blank",
    public: true,
  },
});

const {
  loading,
  error,
  httpDelete,
  httpPostPut,
  httpGet,
  httpPost,
  numberWithCommas,
  formatToMillion,
} = useHttpService();

const keseluruhan = ref();
const responseData = ref(null);
const stateData = ref(null);
const states = ref();

async function loadDataFromApiPasarPbt() {
  try {
    const response = await httpGet("inspektorat/pasar-pbt");

    responseData.value = response;
    keseluruhan.value = response.data.keseluruhan;

    stateData.value = response.data.negeri;
  } catch (err) {
    console.error("loadDataFromApiPasarPbt failed:", err);
  }
}
function getStateData(stateName) {
  if (stateData.value) {
    const data = stateData.value.find((item) => item.state === stateName);

    return data ? data.bilangan_pasar_malam : "0";
  } else {
    return "No data";
  }
}

onMounted(() => {
  loadDataFromApiPasarPbt();
});
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 65%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%);
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%;
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%;
  margin-block-start: 10px;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: start;
}

.pasar {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-block-end: 30px;
}

.pasar-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: auto;
  max-inline-size: 900px;
}

.image-container img {
  border-radius: 10px;
  block-size: auto;
  inline-size: 100%;
}

.text-overlay-left,
.text-overlay-right,
.text-overlay-center {
  position: absolute;
  color: #fff;
  font-family: Arial, sans-serif;
  inset-block-start: 50%;
  transform: translateY(-50%);
}

.text-overlay-left {
  inset-inline-start: 5%;
  text-align: start;
}

.text-overlay-right {
  inset-inline-end: 5%;
  text-align: end;
}

.text-overlay-center {
  inset-inline-start: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
}

.text-overlay-left h3,
.text-overlay-right h3,
.text-overlay-center h3 {
  block-size: 70px;
  color: #150069;
  font-size: 30px;
  font-weight: 600;
}

.text-overlay-left p,
.text-overlay-right p,
.text-overlay-center p {
  margin: 0;
  color: #150069;
  font-size: 28px;
  font-weight: bold;
  line-height: 1.2;
}

.values-side-by-side {
  display: flex;
  flex-wrap: wrap;
  gap: 80px;
}

.values-side-by-side p {
  margin: 0;
}

.number {
  color: #a80000;
}

.text {
  color: #150069;
}

.image-grid {
  display: grid;
  gap: 40px;
  grid-template-columns: repeat(4, 1fr);
  inline-size: 100%;
  max-inline-size: 1200px;
}

.text-overlay {
  position: absolute;
  border-end-end-radius: 10px;
  border-end-start-radius: 10px;
  inline-size: 100%;
  inset-block-end: 0;
  padding-block: 20px;
  padding-inline: 0;
  text-align: center;
}

.state-name {
  color: #a80000;
  font-size: 28px;
  font-weight: 600;
  margin-block-end: 5px;
}

.image-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 10%);
  inline-size: 100%;
  padding-block-start: 110%;
}

.image-container img {
  position: absolute;
  block-size: 100%;
  border-start-end-radius: 10px;
  border-start-start-radius: 10px;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  object-fit: cover;
}

.state-number-large {
  color: #a80000;
  font-size: 32px;
  font-weight: 600;
  margin-block-end: 10px;
  text-align: center;
}

.state-lokasi-large {
  color: #150069;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
}

@media (max-width: 1024px) {
  .content-wrapper {
    max-inline-size: 1000px;
  }

  .pasar-container {
    max-inline-size: 85%;
  }

  .image-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .text-overlay-left h3,
  .text-overlay-right h3,
  .text-overlay-center h3 {
    font-size: 24px;
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
  }

  .pbt-image {
    max-inline-size: 80%;
  }

  .pasar {
    flex-direction: column;
    align-items: center;
  }

  .pasar-container {
    max-inline-size: 90%;
  }

  h2 {
    font-size: 1.2rem;
  }

  .text-overlay-left h3,
  .text-overlay-right h3,
  .text-overlay-center h3 {
    font-size: 1rem;
  }

  .values-side-by-side p {
    font-size: 16px;
  }

  .image-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  h2 {
    font-size: 1rem;
    text-align: left;
  }

  .text-overlay-left h3,
  .text-overlay-right h3,
  .text-overlay-center h3 {
    font-size: 0.8rem;
    line-height: 1.2;
  }

  .text-overlay-left,
  .text-overlay-right,
  .text-overlay-center {
    font-size: 0.9rem;
    inset-block-start: 20%;
  }

  .values-side-by-side {
    gap: 10px;
  }

  .number {
    font-size: 0.8rem;
  }

  .state-name {
    font-size: 2rem;
    position: relative;
    top: -40px;
    text-align: center;
  }

  .state-number-large {
    font-size: 1.8rem;
  }

  .image-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .pasar-container {
    max-inline-size: 100%;
  }
}
</style>
